import styled from "styled-components";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

const TURBO_V2_PAY_BUTTON_HEIGHT = "52px";

/**
 * QC-only pay-button styles — keep out of `styles.ts` so DEFAULT turbo storyshots
 * do not renumber styled-components classes (backward-compatible BAU snapshots).
 */
export const QuickCheckoutPayButton = styled(FullWidthButton)<{ isLoading?: boolean }>(
    ({ theme, isLoading }) => ({
        height: TURBO_V2_PAY_BUTTON_HEIGHT,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing.xxxSmall,
        borderRadius: "12px",
        boxShadow: "0 4px 8px 0 rgba(2, 6, 12, 0.25)",
        // styled(FullWidthButton) className lands on the inner <button>, not the outer wrapper.
        // DLS wraps children in Text maxLines={1} (-webkit-line-clamp), which on iOS clips the
        // QC subtitle ("Final Price") and ellipsizes the title. Reset that label wrapper.
        "& > div > div": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: theme.spacing.xxxSmall,
            overflow: "visible",
            width: "auto",
            WebkitLineClamp: "unset",
            WebkitBoxOrient: "unset",
        },
        "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit",
            border: `1px solid ${theme.colors[theme.colorMode].border_Subtle_Secondary}`,
            pointerEvents: "none",
        },
        ...(isLoading && {
            pointerEvents: "none",
        }),
    }),
);

export const LoaderWrapper = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const Title = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    flexShrink: 0,
    whiteSpace: "nowrap",
}));

export const Subtitle = styled.div({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
});

export const TextDivider = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.xxxSmall}`,
}));
